import type { LanguageType } from '@/pages/opinion/types/common';
import { useMemo } from 'react';
import getBaseColumns from '../utils';
import useLanguage from '@op/hooks/useLanguage';
import { voiceReportingTextAnalysisColumnsFunc } from '../columns/voiceReportingTextAnalysis';

export function useVoiceReportingTextAnalysisColumns({
  languages,
  setLanguages,
  gameInfo,
  filter,
  transIntent
}: {
  languages: LanguageType[];
  gameInfo: any;
  setLanguages?: (languages: LanguageType[]) => void;
  filter: any;
  transIntent: (intent: string) => string;
}) {
  const { formatMessage, formatOptionsMessage } = useLanguage();

  const columns = useMemo(() => {
    const languageSort: LanguageType[] = ['origin', 'en', 'zh'];
    const languageList = languageSort.filter((a: any) =>
      languages?.includes(a),
    );
    const keys = [
      ...languageList,
      'create_time',
      'report_time',
      'language',
      'intent',
      'reason',
      'battle_id',
      'report_open_id',
      'mode',
      'id'
    ];

    const columnsMap = voiceReportingTextAnalysisColumnsFunc({
      formatMessage,
      languages,
      filter,
      firstLanguage: languageList[0],
      setLanguages,
      transIntent
    });

    return getBaseColumns(keys, columnsMap);
  }, [filter, formatMessage, languages, setLanguages]);

  return {
    columns,
    sortColumns: ['create_time', 'report_time']
  };
}
